<template>
  <nav class="bottom">
    <button class="previous" @click="reset" v-if="showFinish">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22L2 12L12 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
      <span>Reset</span>
    </button>
    <div class="spacer" v-else></div>
    <div class="indicator">
      <div class="progress"><div :style="progress"></div></div>
      <div class="percentage">{{ percentage }}%</div>
    </div>
    <button class="next" @click="next" :disabled="!valid" v-if="showNext && !showFinish">
      <span>Next</span>
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L12 12L2 22" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    <div class="spacer" v-else></div>
    <button class="btn-red-wide" @click="finish" v-if="showFinish" :disabled="!valid">
      <span>Get results</span>
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L12 12L2 22" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
  </nav>
</template>
<script>
export default {
  props: {
    step: {
      required: true
    },
    valid: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    },
    percent: {
      default: false
    }
  },
  computed: {
    percentage () {
      return this.percent !== false ? parseInt(this.percent) : parseInt(this.step) * 12.5
    },
    progress () {
      return 'width:' + this.percentage + '%;'
    },
    showFinish () {
      return parseInt(this.step) === 8
    }
  },
  methods: {
    previous () {
      if (parseInt(this.step) === 1) {
        this.$router.push('/')
        return
      }
      this.$router.push('/step/' + (parseInt(this.step) - 1))
    },
    next () {
      this.$router.push('/step/' + (parseInt(this.step) + 1))
    },
    reset () {
      this.$router.push('/')
    },
    async finish () {
      await this.$store.dispatch('submitForm')
    }
  }
}
</script>
<style lang="scss">
@import "./../assets/scss/variables";
@import "./../assets/scss/mixins";
/* stylelint-disable */
#ec-steps {
  nav.bottom {
    background-color: $sol_black;
    height: auto;
    //padding: 1.5rem 2rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    margin-top: 1rem;
    padding: 0 0.5rem;

    button {
      display: none;

      &::before {
        display: none;
      }

      span {
        min-width: 112px;
      }

      &:disabled {
        span {
          color: rgba(#fff, 0.5);
        }

        path {
          stroke: rgba(#fff, 0.5);
        }
      }

      &.previous {
        span {
          text-align: center;
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 1px;
        }

        &:hover {
          background: none;

          &::before {
            display: none;
          }

          span {
            color: #fff;
            text-decoration: underline;
          }

          svg {
            path {
              //stroke: #fff;
              //fill: #fff;
            }
          }
        }
      }

      &.next,
      &.btn-red-wide {
        max-width: inherit;
        min-height: inherit;
        width: auto;

        span {
          text-align: right;
          flex: inherit;
          width: auto;
        }

        @include respond-below(lg) {
          background: $red;
          position: absolute;
          top: -5rem;
          display: flex;
          width: auto;
          left: 1.5rem;
          right: 1.5rem;
          align-items: center;
          min-height: 60px;

          &:hover {
            background: $red75;

            &::before {
              display: none;
            }
          }

          span {
            flex-grow: 1;
            text-align: center;
            margin-right: 10px;
          }
        }

        @include respond-below(md) {
          margin-top: 0;
        }
      }

      &.next {
        span {
          text-align: center;
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 1px;
        }

        &:hover {
          &::before {
            display: none;
          }

          span {
            //color: #231e21;
            text-decoration: underline;
          }

          svg {
            path {
              //stroke: #231e21;
            }
          }
        }
      }
    }

    .spacer {
      display: none;
    }
  }

  .indicator {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 1rem;
    margin: 0 auto;
  }

  .progress {
    width: 100%;
    background-color: #fff;
    border-radius: 4px;
    height: 16px;
    overflow: hidden;
    margin-bottom: 4px;

    div {
      background-color: $red;
      height: 100%;
    }
  }

  .percentage {
    width: 44px;
    text-align: center;

    font-family: $font-family-sans;
    color: #fff;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 1px;
  }

  @include respond-above(lg) {
    nav.bottom {
      height: 85px;
      //padding: 2rem;

      button {
        display: flex;
      }

      .spacer {
        display: block;
      }
    }

    .indicator {
      width: auto;
      flex-direction: row;
    }

    .progress {
      width: 440px;
      margin-bottom: 0;
      margin-right: 1rem;
    }
  }
}
</style>
